<template>
  <a-row :gutter="10">
    <a-col :md="5" :sm="24">
      <a-card :bordered="false">
        <!-- 按钮操作区域 -->
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear :placeholder="$t('请输入区域名称')"/>
          <!-- 树-->
          <a-col :md="24" :sm="24">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    defaultExpandParent
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
      </a-card>
    </a-col>
    <a-col :md="19" :sm="24">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户编号')">
                  <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户姓名')">
                  <a-input :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName"></a-input>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('表编号')">
                    <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('用户手机号')">
                    <a-input :placeholder="$t('请输入用户手机号')" v-model="queryParam.userPhone"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('查询起止时间')">
                  <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                    @change="onDateRangeChange"
                    @ok="onOk"
                  />
                </a-form-item>
              </a-col>
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
          <a-button type="primary" icon="download" @click="handleExportXls('meter_user_water_report_day')">{{ $t('导出') }}</a-button>
          <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
            <a-button type="primary" icon="import">{{ $t('导入') }}</a-button>
          </a-upload>
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
          </a-dropdown>
        </div>

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
            <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
          </div>
          <span style="float:right;">
            <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
              <template slot="content">
                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                  <a-row>
                    <template v-for="item in defColumns">
                      <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                          <a-col :span="6" :key="item.key">
                            <a-checkbox :value="item.dataIndex" :key="item.title">{{ item.title }}</a-checkbox>
                          </a-col>
                      </template>
                    </template>
                  </a-row>
                </a-checkbox-group>
              </template>
            </a-popover>
          </span>

          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            class="j-table-force-nowrap"
            @change="handleTableChange">

            <div slot="filterDropdown">
              <a-card>
                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                  <a-row>
                    <template v-for="item in defColumns">
                      <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                        <a-col :span="6" :key="item.key">
                          <a-checkbox :value="item.dataIndex" :key="item.title">{{ item.title }}</a-checkbox>
                        </a-col>
                      </template>
                    </template>
                  </a-row>
                </a-checkbox-group>
              </a-card>
            </div>
            <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                      <a>{{ $t('删除') }}</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
        </div>
        <meter-user-water-report-day-modal ref="modalForm" @ok="modalFormOk"></meter-user-water-report-day-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUserWaterReportDayModal from './modules/MeterUserWaterReportDayModal'
  import { getAction,putAction } from '@/api/manage'
  import moment from 'moment'
  import Vue from 'vue'

  export default {
    name: 'MeterUserWaterReportCycleList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
      MeterUserWaterReportDayModal
    },
    data () {
      return {
        description: 'meter_user_water_report_day管理页面',
        date:[],
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list:"/jeecg-charge/meter/meterUserWaterReportDay/queryUserWaterFlow",
          // list: "/meter/meterUserWaterReportDay/list",
          delete: "/jeecg-charge/meter/meterUserWaterReportDay/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserWaterReportDay/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUserWaterReportDay/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterUserWaterReportDay/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
      this.initColumns();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },
          {
            title: this.$t('用户keyId  对应用户meter_userinfo表的id'),
            align:"center",
            dataIndex: 'userKeyId'
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId'
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('报表日期'),
            align:"center",
            dataIndex: 'reportDate'
          },
          {
            title: this.$t('上报所属月份 六位整数 高四位代表年份 低二位代表月份 格式如202010 '),
            align:"center",
            dataIndex: 'reportMonth'
          },
          {
            title: this.$t('日冻结用量'),
            align:"center",
            dataIndex: 'dayUse'
          },
          {
            title: this.$t('记录一天用各个时间点的吨数'),
            align:"center",
            dataIndex: 'dayUseDetail'
          },
          {
            title: this.$t('当天上报数据原始二进制字符串'),
            align:"center",
            dataIndex: 'meterUpData'
          },
          {
            title: this.$t('当天上报数据扩展解析字符串'),
            align:"center",
            dataIndex: 'meterUpDataDetail'
          },
          {
            title: this.$t('上期时间 主要针对异常情况或者机械表'),
            align:"center",
            dataIndex: 'preDateTime'
          },
          {
            title: this.$t('上期水表累计流量'),
            align:"center",
            dataIndex: 'preMeterSumFlow'
          },
          {
            title: this.$t('本期抄表时间'),
            align:"center",
            dataIndex: 'thisDateTime'
          },
          {
            title: this.$t('本期水表累计流量'),
            align:"center",
            dataIndex: 'thisMeterSumFlow'
          },
          {
            title:'remark',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title:'remarkRes1',
            align:"center",
            dataIndex: 'remarkRes1'
          },
          {
            title: this.$t('创建日期'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('创建操作员代码'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('修改时间'),
            align:"center",
            dataIndex: 'updateTime'
          },
          {
            title: this.$t('修改操作员Id'),
            align:"center",
            dataIndex: 'updateBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      searchReset() {
        this.date = [];  // 
        this.queryParam = {}
        this.resetAareaData()
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>